import { render, staticRenderFns } from "./WonderUplimitLadder.vue?vue&type=template&id=6468e5a2&scoped=true"
import script from "./WonderUplimitLadder.vue?vue&type=script&lang=js"
export * from "./WonderUplimitLadder.vue?vue&type=script&lang=js"
import style0 from "./WonderUplimitLadder.vue?vue&type=style&index=0&id=6468e5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6468e5a2",
  null
  
)

export default component.exports